import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { checkAccess } from 'app/actions/app.actions';
import * as api from 'dashboard/resources/current-instant-game-liability.api';
import template from './current-instant-game-liability-widget.html';

const mapStateToThis = ({ session, dictionary }) => {
  const { locale, retailer } = session;
  const terms = dictionary.terms[locale];

  return {
    retailer,
    terms,
  };
};

const mapDispatchToThis = {
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class CurrentInstantGameLiabilityWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.showDetails = this.checkAccess('dashboard.widget.gameInventory');
    this.retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchMyCurrentLiability(this.retailerId));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class CurrentInstantGameLiabilityWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = CurrentInstantGameLiabilityWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/current-instant-game-liability/current-instant-game-liability-widget-component.js